import { render } from "./Answer.vue?vue&type=template&id=53ad229a&ts=true"
import script from "./Answer.vue?vue&type=script&lang=ts"
export * from "./Answer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__